import * as React from 'react'
import { QueryResult } from '@apollo/client'
import styled from 'styled-components'
import {
  GqlNotificationListQuery,
  GqlNotificationListQueryVariables,
} from 'generated/graphql'
import Button from '@app.components/Button'
import Pagination from 'app.components/Pagination/Pagination'
import CardTabs, {
  TabType,
} from '../../../app.components/tabs/CardTabs/CardTabs'
import EmptyNotification from '../component/EmptyNotification/EmptyNotification'
import NotificationCard, {
  NotificationCardLoading,
} from '../component/NotificationCard'
import {
  handleClickDeleteNotificationType,
  handleClickNotificationType,
} from '../component/NotificationCard/NotificationCard.types'
import { menuType } from './ScreenNotificationPage.types'

type Props = {
  tabs: TabType[]
  className?: string
  selectedMenu: menuType
  query: QueryResult<
    GqlNotificationListQuery,
    GqlNotificationListQueryVariables
  >
  onClickNotification: handleClickNotificationType
  handleClickDeleteNotification: handleClickDeleteNotificationType
  handleClickDeleteAll: () => void
}

const ScreenNotificationDesktop: React.FC<Props> = ({
  tabs,
  className,
  query,
  onClickNotification,
  handleClickDeleteNotification,
  handleClickDeleteAll,
}) => {
  const { data, loading, error } = query
  return (
    <StyledWrapper className={className}>
      <h1 className="noti-title">알림</h1>
      <CardTabs className="noti-tabs" data={tabs} initialTab={tabs[0]} />
      <div className="tool-bar">
        <Button
          color="grey"
          variant="outlined"
          className="delete-btn"
          onClick={handleClickDeleteAll}
        >
          모두삭제
        </Button>
      </div>
      {/* loading */}
      {loading && (
        <div className="noti-list">
          {new Array(10).fill('').map((_, idx) => (
            <NotificationCardLoading key={idx} />
          ))}
        </div>
      )}
      {/* error */}
      {!data ||
        (error && (
          <div className="noti-list">
            {new Array(5).fill('').map((_, idx) => (
              <NotificationCardLoading key={idx} />
            ))}
          </div>
        ))}
      {/* data view */}
      {!loading && data && (
        <>
          <div className="noti-list">
            {/* empty data */}
            {data.viewerNotifications?.nodes.length === 0 && (
              <EmptyNotification />
            )}
            {data.viewerNotifications?.nodes.map((notification, idx) => (
              <NotificationCard
                key={idx}
                data={notification!}
                onClick={onClickNotification}
                onClickDelete={handleClickDeleteNotification}
              />
            ))}
          </div>
          {data.viewerNotifications?.nodes.length !== 0 && (
            <Pagination
              totalCount={data.viewerNotifications?.totalCount}
              pageSize={20}
              stepSize={10}
              scrollTop
            />
          )}
        </>
      )}
    </StyledWrapper>
  )
}

export default ScreenNotificationDesktop

const StyledWrapper = styled.div`
  .noti-title {
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 30px;
  }
  .noti-tabs {
    margin-bottom: 16px;
  }

  .tool-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
    .delete-btn {
      border: 1px solid #dedede;
      color: #666666;
      padding: 11px 17px;
      &:hover {
        border: 1px solid #999999;
      }
    }
  }
  .noti-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 30px;
  }
`
